import AutoformUiProvider from 'components/autoform/AutoformUiProvider';
import WrapperEmptyState from 'components/layout/WrapperEmptyState';
import Books from 'components/userManagement/Books';
import BooksTabs from 'components/userManagement/BooksTab';
import Groups from 'components/userManagement/Groups';
import GroupsTab from 'components/userManagement/GroupsTab';
import Users from 'components/userManagement/Users';
import UsersTab from 'components/userManagement/UsersTab';
import PageWrapper from 'components/utils/PageWrapper';
import UserManagementPage from 'pages/UserManagement';
import { Navigate } from 'react-router-dom';
import usersPlaceholder from '../images/users-unselected.png';
import groupsPlaceholder from '../images/group-unselected.png';
import { InternalAdminOnlyWrapper } from 'components/utils/InternalAdminOnlyWrapper';
import { USER_MANAGEMENT_ROUTES } from 'constants/routes';

export const userManagementRoutes = {
    path: '/user-management',
    element: (
        <PageWrapper titleId="user_management_title">
            <UserManagementPage />
        </PageWrapper>
    ),
    children: [
        {
            index: true,
            element: <Navigate to={`${USER_MANAGEMENT_ROUTES.USER}/${window.location.search}`} />,
        },
        {
            path: USER_MANAGEMENT_ROUTES.USER,
            element: <UsersTab />,
            children: [
                {
                    index: true,
                    element: <WrapperEmptyState imgSrc={usersPlaceholder} page="users" item="user" noun="properties" />,
                },
                {
                    path: ':hash',
                    element: <Users />,
                },
            ],
        },
        {
            path: USER_MANAGEMENT_ROUTES.GROUPS,
            element: (
                <InternalAdminOnlyWrapper>
                    <GroupsTab />
                </InternalAdminOnlyWrapper>
            ),
            children: [
                {
                    index: true,
                    element: (
                        <WrapperEmptyState imgSrc={groupsPlaceholder} page="groups" noun="properties" item="group" />
                    ),
                },
                {
                    path: ':itemId',
                    element: (
                        <AutoformUiProvider>
                            <Groups />
                        </AutoformUiProvider>
                    ),
                },
            ],
        },
        {
            path: USER_MANAGEMENT_ROUTES.BOOKS,
            element: <BooksTabs />,
            children: [
                {
                    index: true,
                    element: <WrapperEmptyState imgSrc={usersPlaceholder} page="books" noun="properties" item="book" />,
                },
                {
                    path: ':itemId',
                    element: (
                        <AutoformUiProvider>
                            <Books />
                        </AutoformUiProvider>
                    ),
                },
            ],
        },
    ],
};
